module.exports = __webpack_public_path__ + "img/pesquisar.eba88f86.svg";